export default __webpack_public_path__ + "static/media/arrow.e6970f9f.svg";